import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const Bag05OutlineSvg: FC<IconProps> = ({ width = '24', height = '24', ...restProps }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${height}`} {...restProps}>
      <path
        d="M18.4456 5.24995L2.44611 5.24972L2.44507 5.25M18.4456 5.24995L18.4451 16.3467C18.4451 17.3978 17.5768 18.25 16.5057 18.25H4.38446C3.31336 18.25 2.44507 17.3978 2.44507 16.3467V5.25M18.4456 5.24995L15.238 2.04289C15.0504 1.85536 14.7961 1.75 14.5309 1.75H6.35928C6.09407 1.75 5.83971 1.85536 5.65218 2.04289L2.44507 5.25M13.4451 8.25C13.4451 9.90686 12.1019 11.25 10.4451 11.25C8.78821 11.25 7.44507 9.90686 7.44507 8.25"
        stroke={restProps.stroke}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export const Bag05OutlineIcon = createStandardIcon(Bag05OutlineSvg)
